export class GeographicFilterModel {  
  private _fieldDivisionID: string;
  private _fieldDivisionGroupID: string;
  private _stateID: string;
  private _countyID: string;
  private _agencyID: string;
  private _fieldDivisionName: string;
  private _groupName: string;
  private _fieldDivisionGroups: ServerModels.FieldDivisionGroupViewModel[];
  private _groupNameList: string;
  private _stateName: string;
  private _countyName: string;
  private _counties: ServerModels.ENESS_REF_Counties[] = [];
  private _countyNameList: string;
  private _agencyName: string;
  private _agencies: ServerModels.ENESS_REF_Agency[] = [];
  private _agencyNamesList: string;

  constructor(fieldDivisionID: string, fieldDivisionGroupID: string, fieldDivisionGroups: ServerModels.FieldDivisionGroupViewModel[], stateID: string, countyID: string, counties: ServerModels.ENESS_REF_Counties[], agencyID: string, agencies: ServerModels.ENESS_REF_Agency[], fieldDivisionName: string, groupName: string, groupNameList: string, stateName: string, countyName: string, countyNamesList: string, agencyName: string, agencyNamesList: string) {
    this._fieldDivisionID = fieldDivisionID;
    this._fieldDivisionGroupID = fieldDivisionGroupID;
    this._fieldDivisionGroups = fieldDivisionGroups;
    this._stateID = stateID;
    this._countyID = countyID;
    this._counties = counties;
    this._agencyID = agencyID;
    this._agencies = agencies;
    this._fieldDivisionName = fieldDivisionName;
    this._groupName = groupName;
    this._groupNameList = groupNameList;
    this._stateName = stateName;
    this._countyName = countyName;
    this._countyNameList = countyNamesList;
    this._agencyName = agencyName;
    this._agencyNamesList = agencyNamesList;
  }  

  get fieldDivisionID(): string {
    return this._fieldDivisionID;
  }

  set fieldDivisionID(id: string) {
    this._fieldDivisionID = id;
  }

  get fieldDivisionGroupID(): string {
    return this._fieldDivisionGroupID;
  }

  set fieldDivisionGroupID(id: string) {
    this._fieldDivisionGroupID = id;
  }

  get stateID(): string {
    return this._stateID;
  }

  set stateID(id: string) {
    this._stateID = id;
  }

  get countyID(): string {
    return this._countyID;
  }

  set countyID(id: string) {
    this._countyID = id;
  }

  get counties(): ServerModels.ENESS_REF_Counties[] {
    return this._counties;
  }

  set counties(counties: ServerModels.ENESS_REF_Counties[]) {
    this._counties = counties;
  }

  get agencyID(): string {
    return this._agencyID;
  }

  set agencyID(id: string) {
    this._agencyID = id;
  }

  get agencies(): ServerModels.ENESS_REF_Agency[] {
    return this._agencies;
  }

  set agencies(agencies: ServerModels.ENESS_REF_Agency[]) {
    this._agencies = agencies;
  }
  get fieldDivisionName(): string {
    return this._fieldDivisionName;
  }

  set fieldDivisionName(fd: string) {
    this._fieldDivisionName = fd;
  }

  get fieldDivisionGroups(): ServerModels.FieldDivisionGroupViewModel[] {
    return this._fieldDivisionGroups;
  }

  set fieldDivisionGroups(groups: ServerModels.FieldDivisionGroupViewModel[]) {
    this._fieldDivisionGroups = groups;
  }

  get groupName(): string {
    return this._groupName;
  }

  set groupName(group: string) {
    this._groupName = group;
  }

  get groupNameList(): string {
    return this._groupNameList;
  }

  set groupNameList(groups: string) {
    this._groupNameList = groups;
  }

  get stateName(): string {
    return this._stateName;
  }

  set stateName(state: string) {
    this._stateName = state;
  }

  get countyName(): string {
    return this._countyName;
  }

  set countyName(county: string) {
    this._countyName = county;
  }

  get countyNameList(): string {
    return this._countyNameList;
  }

  set countyNameList(countyNames: string) {
    this._countyNameList = countyNames;
  }

  get agencyName(): string {
    return this._agencyName;
  }

  set agencyName(agency: string) {
    this._agencyName = agency;
  }

  get agencyNamesList(): string {
    return this._agencyNamesList;
  }

  set agencyNamesList(agencyNames: string) {
    this._agencyNamesList = agencyNames;
  }
}
